export default __webpack_public_path__ + "static/media/ai-art-icon.5948bf51.svg";